import { NgModule } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterModule,
  RouterStateSnapshot,
  Routes,
} from "@angular/router";
import { AdminPanelComponent } from "./admin-panel/admin-panel.component";
import { ComuniComponent } from "./comuni/comuni.component";
import { GruppiComponent } from "./gruppi/gruppi.component";
import { StatiIncaricoComponent } from "./stati-incarico/stati-incarico.component";
import { StudiComponent } from "./studi/studi.component";
import { RamiComponent } from "./rami/rami.component";
import { UsersComponent } from "./users/users.component";
import { TipiTemplateComponent } from "./tipi-template/tipi-template.component";
import { CollegamentiComponent } from "./collegamenti/collegamenti.component";
import { SuggerimentiComponent } from "./suggerimenti/suggerimenti.component";
import { ZoneGeograficheComponent } from "./zone-geografiche/zone-geografiche.component";
import { GruppiRamiComponent } from "./gruppi-rami/gruppi-rami.component";
import { GruppiTipiDannoComponent } from "./gruppi-tipi-danno/gruppi-tipi-danno.component";
import { EstensioniComponent } from "./estensioni/estensioni.component";
import { FilialiComponent } from "./filiali/filiali.component";
import { AnnunciComponent } from "./annunci/annunci.component";
import { DisposizioniCompagnieComponent } from "./disposizioni-compagnie/disposizioni-compagnie.component";
import { WorkflowStepsComponent } from "./workflow-steps/workflow-steps.component";
import { PreferenzeAgenzieComponent } from "./preferenze-agenzie/preferenze-agenzie.component";
import { PreferenzeAmministratoriComponent } from "./preferenze-amministratori/preferenze-amministratori.component";

const routes: Routes = [
  {
    path: "",
    component: AdminPanelComponent,
    children: [
      {
        path: "users",
        component: UsersComponent,
        data: { title: "Utenti" },
      },
      {
        path: "comuni",
        component: ComuniComponent,
        data: { title: "Comuni" },
      },
      {
        path: "stati-incarico",
        component: StatiIncaricoComponent,
        data: { title: "Stati Incarico" },
      },
      {
        path: "tipi-polizze",
        component: RamiComponent,
        data: { title: "Stati Incarico" },
      },
      {
        path: "studi",
        component: StudiComponent,
        data: { title: "Studi" },
      },
      {
        path: "filiali",
        component: FilialiComponent,
        data: { title: "Filiali" },
      },
      {
        path: "gruppi",
        component: GruppiComponent,
        data: { title: "Gruppi" },
      },
      {
        path: "collegamenti",
        component: CollegamentiComponent,
        data: { title: "Collegamenti" },
      },
      {
        path: "zone-geografiche",
        component: ZoneGeograficheComponent,
        data: { title: "Zone Geografiche" },
      },
      {
        path: "gruppi-rami",
        component: GruppiRamiComponent,
        data: { title: "Gruppi Rami" },
      },
      {
        path: "gruppi-tipi-danno",
        component: GruppiTipiDannoComponent,
        data: { title: "Gruppi Tipi Danno" },
      },
      {
        path: "suggerimenti",
        component: SuggerimentiComponent,
        data: { title: "Suggerimenti" },
      },
      {
        path: "annunci",
        component: AnnunciComponent,
        data: { title: "Annunci" },
      },
      {
        path: "disposizioni-compagnie",
        component: DisposizioniCompagnieComponent,
        data: { title: "Disposizioni Compagnie" },
      },
      {
        path: "workflow-steps",
        component: WorkflowStepsComponent,
        data: { title: "Workflow" },
      },
      {
        path: "templates",
        loadChildren: () =>
          import("./templates/templates.module").then((m) => m.TemplatesModule),
        data: { title: "Templates per generazione documenti" },
      },
      {
        path: "segnalibri",
        loadChildren: () =>
          import("./segnalibri/segnalibri.module").then(
            (m) => m.SegnalibriModule
          ),
        data: { title: "Segnalibri per generazione documenti" },
      },
      {
        path: "tipi-template",
        component: TipiTemplateComponent,
        data: { title: "Tipi di template" },
      },
      {
        path: "tipi-altro-soggetto",
        loadChildren: () =>
          import("./tipi-altro-soggetto/tipi-altro-soggetto.module").then(
            (m) => m.TipiAltroSoggettoModule
          ),
        data: { title: "Tipi altro soggetto per generazione documenti." },
      },
      {
        path: "estensioni",
        component: EstensioniComponent,
        data: { title: "Estensioni" },
      },
      {
        path: "preferenze-agenzie",
        component: PreferenzeAgenzieComponent,
        data: { title: "Preferenze Agenzie" },
      },
      {
        path: "preferenze-amministratori",
        component: PreferenzeAmministratoriComponent,
        data: { title: "Preferenze Amministratori" },
      },
      {
        path: "",
        component: UsersComponent,
        data: { title: "Utenti" },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRoutingModule {}
